<template>
  <v-generic-input
    :label="label"
    :translate-text="translateText"
    :help-text="helpText"
    :id="`${givenId}`"
    :required="required"
    :errors="errors"
  >
    <template v-slot:input>
      <input
        :id="`${givenId}`"
        ref="textInput"
        class="form-control bg-lightest p-2"
        :class="[`form-control-${size}`]"
        v-model="inputVal"
        :type="type"
        :placeholder="$t(placeholder)"
        :required="required"
        :maxlength="maxLength || false"
        :disabled="disabled"
        @focus="autoSelect ? $event.target.select() : null"
      />
    </template>
  </v-generic-input>
</template>

<script>
import { GenericInputMixin } from '@/common/utils/mixins';
import _GenericInput from './_GenericInput.vue';

export default {
  name: 'TextInput',
  components: {
    'v-generic-input': _GenericInput,
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    maxLength: {
      type: Number,
    },
    autoFocus: {
      type: Boolean,
      default() {
        return false;
      },
    },
    autoSelect: {
      // Selects the text in the input field when focused;
      type: Boolean,
      default() {
        return false;
      },
    },
    size: {
      type: String,
      default() {
        return 'md';
      },
    },
    value: {
      type: String,
    },
    type: {
      type: String,
      default() {
        return 'text';
      },
    },
  },
  mixins: [
    GenericInputMixin,
  ],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  data() {
    return {
      givenId: null,
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.givenId = this.id || this._uid;

    if (this.autoFocus) {
      this.$refs.textInput.focus();
    }
  },
};
</script>
